(function () {
  const GIFT_VARIANT_ID = 51327426625700;
  const MIN_CART_TOTAL_CENTS = 6500; // SGD 65.00 (Shopify cart API returns cents)

  let working = false;
  let lastSubQty = null; // total qty of subscription items seen so far (null = not measured yet)

  function subscriptionQty(items) {
    return items.reduce(
      (total, item) => total + (item.selling_plan_allocation != null ? item.quantity : 0),
      0
    );
  }

  function giftIsInCart(items) {
    return items.some((item) => item.variant_id === GIFT_VARIANT_ID);
  }

  function isFirstTimeCustomer() {
    const customer = window.ECTheme && window.ECTheme.customer;
    if (!customer) return true; // guest — can't verify history, assume first time
    return customer.orders_count === 0;
  }

  function cartIsEligible(cart) {
    return isFirstTimeCustomer() && cart.total_price >= MIN_CART_TOTAL_CENTS;
  }

  function addGiftToCart() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 }),
    })
      .then((res) => res.json())
      .then(() => {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gk-free-gift' });
        }
      });
  }

  // The gift is a normal cart line — the shopper can remove it freely. We (re)add
  // it only when a NEW subscription plan is added, i.e. the total subscription
  // quantity goes up. Removing the gift doesn't change that count, so it stays
  // removed; adding another plan brings it back. The giftIsInCart check means a
  // cart never holds more than one gift.
  function considerCart(cart) {
    if (!cart || !cart.items) return;

    const currentSubQty = subscriptionQty(cart.items);
    const previousSubQty = lastSubQty;
    lastSubQty = currentSubQty;

    if (previousSubQty === null) return;          // first read just sets the baseline
    if (currentSubQty <= previousSubQty) return;  // no new plan was added
    if (working) return;
    if (!cartIsEligible(cart)) return;
    if (giftIsInCart(cart.items)) return;

    working = true;
    addGiftToCart()
      .catch(() => {}) // a failed add changes nothing; the next plan-add can retry
      .finally(() => { working = false; });
  }

  function fetchCartAndConsider() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => considerCart(cart))
      .catch(() => {});
  }

  // The subscription product is added by a third-party app whose request does
  // not always publish the theme's cartUpdate event, so we also watch fetch for
  // cart mutations. This only reacts after a request completes; it never blocks
  // or alters the request itself.
  const _fetch = window.fetch;
  window.fetch = function () {
    const result = _fetch.apply(this, arguments);
    const url = typeof arguments[0] === 'string'
      ? arguments[0]
      : (arguments[0] && arguments[0].url) || '';
    if (url.includes('/cart/add') || url.includes('/cart/change')) {
      result.then(() => fetchCartAndConsider()).catch(() => {});
    }
    return result;
  };

  // Native pub/sub hook for theme-driven cart updates.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source === 'gk-free-gift') return; // our own add
      if (event && event.cartData) {
        considerCart(event.cartData);
      } else {
        fetchCartAndConsider();
      }
    });
  }

  // Establish the subscription-quantity baseline as soon as possible on load.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCartAndConsider);
  } else {
    fetchCartAndConsider();
  }
})();
